<template>
    <div class="component ar-modal" :class="{ 'is-visible': isModalVisible, 'is-hidden': !isArModalOpen }">
        <div class="modal-wrapper">
            <div class="wrapper-medium">
                <div class="modal">        
                    <div class="steps">            
                        <div class="ar-step">
                            <img class="phone-content" src="../assets/svg/ar/step0.svg" />
                            <img class="phone" src="../assets/svg/ar/phone.svg" />
                            <p>01</p>
                            <p>Scan the<br>QR Code</p>
                        </div>

                        <div class="ar-step">
                            <img class="phone-content" src="../assets/svg/ar/step0.svg" style="opacity:0.25;"/>
                            <img class="phone-content" src="../assets/svg/ar/step1.svg" />
                            <img class="phone" src="../assets/svg/ar/phone.svg" />
                            <p>02</p>
                            <p>Open Link to<br>download App</p>
                        </div>

                        <div class="ar-step brk"></div>

                        <div class="ar-step">
                            <div class="store-buttons">
                                <a href="https://apps.apple.com/de/app/liquid-design-ar/id1541328060" target="_blank"><img class="store-button-icon" src="../assets/svg/ar/appleAppStoreButton.svg" /></a>
                                <a href="https://play.google.com/store/apps/details?id=com.telekom.liquiddesignar" target="_blank"><img class="store-button-icon" src="../assets/svg/ar/googlePlayStoreButton.svg" /></a>
                            </div>
                            <img class="phone" src="../assets/svg/ar/phone.svg" />
                            <p>03</p>
                            <p>Download and<br>start AR-App</p>
                        </div>

                        <div class="ar-step">
                            <img class="phone-content" src="../assets/svg/ar/step3.svg" />
                            <img class="phone" src="../assets/svg/ar/phone.svg" />
                            <p>04</p>
                            <p>Download the<br>poster and scan it</p>
                        </div>
                    </div>
                    <a href="https://liquid-design-ar.telekom.com/data/Telekom_Liquid_Design_AR_Poster.pdf" target="_blank" class="download-button">
                        <button-icon
                            class="button-icon"
                            icon="arrowDown"
                            text="Download Poster"
                            hasText
                        />
                    </a>
                </div>
            </div>
        </div>
        <button-icon icon="close" @click.native="closeOverlay()" />
        <div class="modal-background"></div>
    </div>
</template>

<script>
    import ButtonIcon from './patterns/buttons/ButtonIcon';

    export default {
        name: 'ArModal',
        components: {
            ButtonIcon,
        },
        data() {
            return {
                isModalVisible: false,
            };
        },
        computed: {
            isArModalOpen() {
                return this.$store.getters.isArModalOpen;
            },
        },
        watch: {
            isArModalOpen(newValue, oldValue) {
                if (newValue) {
                    this.isModalVisible = true;
                }

              
            },
        },
        methods: {
            onReady() {
                function iOS() {
                    return (
                        ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
                            navigator.platform
                        ) ||
                        (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
                    );
                }

                if (this.isArModalOpen && !iOS()) {
                    this.$refs.player.play();
                }
            },
            closeOverlay() {
                
                this.isModalVisible = false;

                // use proper css transition event listener later
                setTimeout(() => {
                    this.$store.dispatch('toggleArModal');
                }, 500);
            }
        },
    };
</script>

<style lang="scss" scoped>
    .steps{
        position: relative;
        @include flex($justify-content: space-between, $align-items: center);
        align-items: flex-start;
        @media (max-width: breakpoint('small')) {        
            justify-content: center;
        }       
        width:100%;
        
        .ar-step{
            align-self: stretch;
            &.brk{
                display: none;
                flex-basis:100%;
                height:0px;
                margin:0px;
                @media (max-width: breakpoint('small')) {
                    display: inline-block;
                    }
                }
                position: relative;
                display: inline-block; 
                width:auto;
                
                @media (max-width: breakpoint('medium')) {
                    width: 20%;
                }   
                @media (max-width: breakpoint('small')) {
                    width: 80px;
                    margin-left:20px;
                    margin-right:20px;
                    margin-bottom:10px;
                }
            .phone-content,.store-buttons{
                position: absolute;
                top:0px;
                left:0px;
                width:100%;
            }

            .store-buttons{
                top:12%;
                .store-button-icon{
                width:75%;
                margin-bottom: 5px;
            }
        }

        .phone{
            width:100%;
        }
        p{
            color:#FFF;
            text-align: center;
            margin-top:10px;
            @media (max-width: breakpoint('medium')) {
                font-size: 16px;
                
            }
             @media (max-width: breakpoint('small')) {
                 font-size: 12px;
                 margin-top:0px;
             }
        }
    }}
    .ar-modal {
        position: fixed;
        z-index: 10;
        width: 100%;
        height: 100%;

        [class^='wrapper'] {
            @media (max-width: breakpoint('medium')) {
                width: 100%;
                max-width: none;
            }
        }

        .modal-wrapper {
            position: fixed;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            transition: transform 0.3s, opacity 0.3s;
            z-index: 1;

            @media (max-width: breakpoint('medium')) {
                width: calc(100% - 50px);
            }

            @media (max-width: breakpoint('small')) {
                width: calc(100% - 30px);
            }
        }

        .modal-background {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.9);
            transition: opacity 0.5s;
            opacity: 0;
        }

        .modal {
            position: relative;
           text-align: center;
           opacity: 0;
            transition: opacity 0.5s;
        }

        .wrapper-video {
            width: 100%;
            position: relative;
            padding-top: calc(100% / (16 / 9));
            opacity: 0;
            transition: opacity 0.5s, transform 0.5s;
            transform: translateY(30px);
        }

        .vimeo-container {
            position: absolute;
            width: 100% !important;
            top: 0;
            left: 0;
        }

        .btn {
            position: absolute;
            right: 30px;
            top: 30px;
            z-index: 1;
            opacity: 0;
            transition: opacity 0.3s, transform 0.3s;

            @media (max-width: breakpoint('small')) {
                right: 15px;
                top: 15px;
            }
        }

        &.is-hidden {
            opacity: 0;
            pointer-events: none;
        }

        &.is-visible {
            opacity: 1;
            pointer-events: all;

            .modal-background,
            .modal,
            .btn {
                opacity: 1;
            }

            .wrapper-video.is-ready {
                opacity: 1;
                transform: translateY(0);
            }
        }

        @media (max-width: breakpoint('medium')) {
            width: 100%;
            transform: translate(0%, 100%);
            left: 0;
            bottom: 0;

            &.is-visible {
                transform: translate(0%, 0%);
            }
        }

        .wrapper-medium {
            @media (min-width: breakpoint('large')) {
                width: 1200px;
            }
        }
    }
    .download-button{
        .button-icon{
            position: relative;
            top:inherit;
            left:inherit;
            right:inherit;
            bottom:inherit;
        }
        
        margin-top:20px;
        display: inline-block;

    }
</style>
